import React from "react";
import { Blocks } from "react-loader-spinner";



const BlockLoader = ({
    message = "Pujant immoble... Esperi un moment...",

}) => {
    return (
        <div style={overlayStyle}>
            <Blocks
                height={60}
                width={60}


            />
            <p style={messageStyle}>{message}</p>
        </div>
    );
};

const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.38)", // Fondo semitransparente
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
};

const messageStyle = {
    marginTop: "16px",
    color: "white",
    fontSize: "18px",
    fontWeight: "bold",
};

export default BlockLoader;
